export default {
    OPTIONS: {
        SERVICE_LEVEL: {
            ETICKET: 'ETICKET',
            MOBILE: 'MOBILE',
            MOBILETICKET: 'MOBILETICKET',
            DIGITAL: 'DIGITAL',
            TICKETFAST: 'TICKETFAST',
            ELECTRONIC: 'ELECTRONIC'
        },
        SERVICE_LEVEL_SORT: {
            ETICKET: 0,
            MOBILE: 1,
            MOBILETICKET: 2,
            DIGITAL: 3,
            TICKETFAST: 4,
            ELECTRONIC: 5,
            OTHER: 6
        }
    }
};